import Model from '@/models/Model.js';
import axios from '@/plugins/axios.js';
import { postProctorDashboardForceStatus } from '@/utilities/proctorDashboardForceStatus.js';
import QueryBuilder from '@/utilities/QueryBuilder.js';

export default class Remediation extends Model {
    static entity = 'remediation';

    static queryBuilder(id = null) {
        const endpoint = id ? `${this.entity}/${id}` : this.entity;

        return new QueryBuilder(endpoint);
    }

    static fields() {
        return {
            remediation_status: this.attr(null),
            id: this.attr(null),
            activity_id: this.attr(null),
            activity_submission_id: this.attr(null),
            activity_submission: this.attr(null),
            course_grade: this.attr(null),
            course_percentage: this.attr(null),
            comment: this.attr(null),
            quiz_time_limit: this.attr(null),

            course_id: this.attr(null),
            user_id: this.attr(null),

            logs: this.attr(null),

            ...super.fields(),

            activity: this.attr(null),
            course: this.attr(null),
            statuses: this.attr(null),

            user: this.belongsTo('users', 'user_id'),
        };
    }

    static fetch(id) {
        this.api().get(this.queryBuilder(id).toUrl());
    }

    static fetchAll({ page = 1 }) {
        return this.api().get(this.queryBuilder().page(page).toUrl());
    }

    updateStatusToCheckIn() {
        return Remediation.update({
            where: this.id,
            data: {
                statuses: [{ name: 'checked-in' }],
            },
        });
    }

    async updateStatusToWaitingRoom() {
        const payload = {
            quiz_activity_id: this.activity.contentable_id,
            quiz_version_id: this.activity.contentable.quiz_version_id,
            is_preview: false,
            password: null,
            status: 'in-waiting-room',
            users: [this.user_id],
            proctor_dashboard: true,
            model_type: 'remediation',
            model_id: this.id,
        };

        const forceStatus = new QueryBuilder('quiz-attempt-force-status');

        try {
            const response = await axios.post(forceStatus.toUrl(), payload);

            if (response.status === 200) {
                Remediation.update({
                    where: this.id,
                    data: {
                        statuses: [{ name: 'in-waiting-room' }],
                    },
                });
            }
        } catch (_error) {}
    }

    async startQuiz() {
        const payload = {
            quiz_activity_id: this.activity.contentable_id,
            quiz_version_id: this.activity.contentable.quiz_version_id,
            is_preview: false,
            password: null,
            status: 'attempt-started',
            users: [this.user_id],
            proctor_dashboard: true,
            model_type: 'remediation',
            model_id: this.id,
        };

        const forceStatus = new QueryBuilder('quiz-attempt-force-status');

        try {
            const response = await axios.post(forceStatus.toUrl(), payload);

            if (response.status === 200) {
                Remediation.update({
                    where: this.id,
                    data: {
                        statuses: [{ name: 'attempt-started' }],
                    },
                });
            }
        } catch (error) {
            console.error(error);
        }
    }

    async waitingRoomEnd() {
        const payload = {
            quiz_activity_id: this.activity.contentable_id,
            quiz_version_id: this.activity.contentable.quiz_version_id,
            is_preview: false,
            password: null,
            status: 'in-waiting-room-post',
            users: [this.user_id],
            proctor_dashboard: true,
            model_type: 'remediation',
            model_id: this.id,
        };

        const forceStatus = new QueryBuilder('quiz-attempt-force-status');

        try {
            const response = await axios.post(forceStatus.toUrl(), payload);

            if (response.status === 200) {
                Remediation.update({
                    where: this.id,
                    data: {
                        statuses: [{ name: 'in-waiting-room-post' }],
                    },
                });
            }
        } catch (error) {
            console.error(error);
        }
    }

    async inReview() {
        const payload = {
            quiz_activity_id: this.activity.contentable_id,
            quiz_version_id: this.activity.contentable.quiz_version_id,
            is_preview: false,
            password: null,
            status: 'in-review',
            users: [this.user.id],
            proctor_dashboard: true,
            model_type: 'remediation',
            model_id: this.id,
        };

        const forceStatus = new QueryBuilder('quiz-attempt-force-status');

        try {
            const response = await axios.post(forceStatus.toUrl(), payload);

            if (response.status === 200) {
                Remediation.update({
                    where: this.id,
                    data: {
                        statuses: [{ name: 'in-review' }],
                    },
                });
            }
        } catch (error) {
            console.error(error);
        }
    }

    async endQuiz() {
        const payload = {
            quiz_activity_id: this.activity.contentable_id,
            quiz_version_id: this.activity.contentable.quiz_version_id,
            is_preview: false,
            password: null,
            status: '',
            users: [this.user.id],
            proctor_dashboard: true,
            model_type: 'remediation',
            model_id: this.id,
        };

        await postProctorDashboardForceStatus(payload);

        this.markFinished();
    }

    markFinished() {
        Remediation.update({
            where: this.id,
            data: {
                statuses: [{ name: 'finished', created_at: new Date().toISOString() }],
            },
        });
    }
}
